export const creditAmountValidate = (creditArray,currentData,remainingAmount) => {
    const newErrors = {}; 
     
    const sum = creditArray?.reduce((acc, current) => {
      if (current?.amt && current?.amt !== '') {
        return acc + parseFloat(current?.amt);
      } else {
        return acc;
      }
    }, 0);  
   
        if (!currentData.amt) {
          newErrors[`amount`] = "Credit Amount is Required!";
        } else if(sum > remainingAmount){
            newErrors[`amount`] = "The amount entered exceeds the available limit.";
        }
       
        if (!currentData.pmtDt) {
          newErrors[`paymentDate`] = "Credit Date is Required!";
        }  
      
      return newErrors;
    };
  
    export const addCreditAmountValidate = (creditArray,totalCreditAmount) => {
      const newErrors = {}; 
      const creditItems = creditArray?.map((item)=>{
        if(item?.crId){
          return {
            ...item?.crId,
            usAmt:item?.usAmt
          };
        }
        else{
          return item;
        }
      })
    
      creditItems.forEach((credit, index) => {
          if (!credit.usAmt) {
            newErrors[`credit.${index}.useAmount`] = "Amount is Required!";
          } 
        });
        return newErrors;
      };
    